// Quotes a value only when a CSV reader would otherwise misread it.
export const escapeCSVValue = value => {
  if (value === null || value === undefined) return '';
  const text = String(value);
  return /[",\n\r\t]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const toCsv = (columns, rows) =>
  [columns, ...rows].map(row => row.map(escapeCSVValue).join(',')).join('\r\n');
